import { DisplaySchema, ObjectSchema, ViewConfig } from '@summit/models';
import { StatusSync } from './status-sync';

export class StatusSyncSchema extends DisplaySchema<StatusSync> {
  readonly refTitle = 'Status Sync';
  override readonly refServerAPI = 'StatusSync';
  readonly refColumnList: ObjectSchema<StatusSync> = {
    id: { propertyName: 'id', formField: true }
  };
  readonly refViewModels: ViewConfig<StatusSync>[] = [];

  NewObject(jsonData?: Partial<StatusSync>): StatusSync {
    return new StatusSync(jsonData);
  }
}
